'use client'
import Parkinglot from '@/components/detail/components/parkinglot/view'
import SharedParkinglot from '@/components/detail/components/sharedParkinglot/view'
import useDetailClientViewModel from '@/components/detail/viewModel'
import { useRecommendParkinglotViewModel } from '@/components/recommendParkinglot/viewModel'
import RoadView from '@/components/roadview/view'

import Button from '@/shared/components/button/Button'
import Confirm from '@/shared/components/modal/Confirm'
import Modal from '@/shared/components/modal/Modal'
import { Text } from '@/shared/components/typography'

import { PARKINGLOT_TYPE } from '@/enums/detail'

import { ParkinglotDetail, SharedParkinglotDetail, TicketsItem } from '@/api/server/detail/dto/detailDto'

interface DetailViewProps {
  pin: ParkinglotDetail | SharedParkinglotDetail
  tickets: TicketsItem[]
  geoCodeNeighborsWithSelf: string
  id: string
  type: string
}

export default function DetailClientView({ pin, tickets, geoCodeNeighborsWithSelf, id, type }: DetailViewProps) {
  const currentParkinglotPosition = {
    lat: pin.basic.latitude,
    lng: pin.basic.longitude
  }
  const { states: RPLstates } = useRecommendParkinglotViewModel({
    currentParkinglotPosition,
    id,
    geoCodeNeighborsWithSelf
  })

  const { states, setters, handlers } = useDetailClientViewModel({ type, id })
  const { isRoadViewOpen, sheetType, parkinglotRef, sheetPositionY, isNotFoundPinsModalOpen } = states
  const { setIsRoadViewOpen } = setters
  const { onCloseModal } = handlers

  const confirmTitle = (
    <div className="pb-5 pt-6 font-medium">
      <Text level="text1" weight="medium" color="text090">
        현재 주차가 불가합니다
      </Text>
    </div>
  )
  const confirmFooter = (
    <div className="flex w-full gap-2">
      <Button text="확인" background="main050" color="text010" onClick={onCloseModal} />
    </div>
  )

  const bodyText = (
    <Text level="text2" color="text090">
      다른 운전자가 주차 중이거나,
      <br /> 공유 시간이 아닙니다.
      <br /> 주변 주차장을 이용해 주세요.
    </Text>
  )

  if (states.isRoadViewOpen)
    return (
      <RoadView
        isRoadViewOpen={isRoadViewOpen}
        setIsRoadViewOpen={setIsRoadViewOpen}
        latitude={pin.basic.latitude}
        longitude={pin.basic.longitude}
      />
    )

  return (
    <>
      {/* 일반주차장 && (요약정보 | 상세페이지)*/}
      {pin.type === PARKINGLOT_TYPE.PARKINGLOT && (
        <Parkinglot
          ref={parkinglotRef}
          pin={pin}
          tickets={tickets}
          isRoadViewOpen={isRoadViewOpen}
          setIsRoadViewOpen={setIsRoadViewOpen}
          sortedParkinglots={RPLstates.sortedParkinglots}
          sheetType={sheetType}
          sheetPositionY={sheetPositionY}
        />
      )}
      {/* 공유주차장 && 요약정보 */}
      {pin.type === PARKINGLOT_TYPE.SHARE && (
        <SharedParkinglot
          ref={parkinglotRef}
          pin={pin}
          isRoadViewOpen={isRoadViewOpen}
          setIsRoadViewOpen={setIsRoadViewOpen}
          sortedParkinglots={RPLstates.sortedParkinglots}
          sheetType={sheetType}
          sheetPositionY={sheetPositionY}
        />
      )}
      <Modal
        targetId="#layer1"
        title={confirmTitle}
        isOpen={isNotFoundPinsModalOpen}
        onClose={onCloseModal}
        footer={confirmFooter}
      >
        <Confirm bodyText={bodyText} className="mb-5 break-keep px-2 text-center" />
      </Modal>
    </>
  )
}
